import React from 'react';

const ProjectHeader = ({ projectName, subtitle, bulletPoints, imgSrc }) => {
  return (
    <section className="project-header">
      <h2>{projectName}</h2>
      <p className="caseIntro">{subtitle}</p>
      <div className="project-header-main">
        <div className="header-description left">
          <div>
            {bulletPoints.map(({ name, content, isHTML }) => {
              return (
                <p>
                  <strong>{name}</strong>
                  <br />
                  {isHTML ? (
                    <span dangerouslySetInnerHTML={content} />
                  ) : (
                    content
                  )}
                </p>
              );
            })}
          </div>
        </div>
        <div className="header-coverImg right">
          <img className="img-responsive img-centered" src={imgSrc} alt="" />
        </div>
      </div>
    </section>
  );
};

export default ProjectHeader;



// WEBPACK FOOTER //
// ./src/Modules/Case/ProjectHeader.js